<template>
   <div
      class="flightcard-inner-wrapper"
      :class="[
         flight.familyPrice != null ? 'has-family-price' : '',
         flight.familyPrice == 0 ? 'not-has-family-price' : '',
         flight.isSelected ? 'is-selected' : '',
         flight.isSelected && !isOneWay && flight.familyPrice != null && FamilyPriceView.basketCreated && !FamilyPriceView.checkoutEnabled ? 'de-emphasize' : '',
         isPackagePrice() ? 'is-package' : '',
         familyPricesToggle && flight.cheapestFamilyPrice?.price && !isCheckOutEnabled && !flight.isSelected ? getClassForFamilyPriceView(flight.cheapestFamilyPrice?.price) : '',
         flight.isHiddenFromUI ? 'flightcard-collapsed' : '',
      ]"
      :data-identifier="flight.identifier"
      :data-price="flight.price"
      v-if="FilterBy"
      :data-leg="flight.legIndex">
      <ul v-if="false" @click="handlerSelectFlight">
         <li>
            <span>isSelected:</span>
            <span>{{ flight.isSelected }}</span>
         </li>
         <li>
            <span>priceViewMode:</span>
            <span>{{ priceViewMode }}</span>
         </li>
         <li>
            <span>familiesPackagePrices:</span>
            <span>{{ flight.familiesPackagePrices }}</span>
         </li>
         <li>
            <span>family Price:</span>
            <span>{{ flight.familyPrice }}</span>
         </li>
         <li>
            <span>cheapestFamilyPrice:</span>
            <span>{{ flight.cheapestFamilyPrice?.price }}</span>
         </li>
         <li>
            <span>Price:</span>
            <span>{{ flight.price }}</span>
         </li>
         <li>
            <span>isCheckOutEnabled:</span>
            <span>{{ isCheckOutEnabled }}</span>
         </li>
      </ul>
      <template v-else>
         <div class="flightcard-header d-lg-none">
            <div class="flightcard-header-left">
               <img class="airline-logo" :src="handlerAirlineImg(flight.marketingAirlineCode)" alt="" @error="handlerUnknownImg($event)" />
               <div class="airline-informations">
                  <div class="marketing-airline">
                     <span class="airline">{{ flight.marketingAirline }}</span>
                  </div>
                  <div class="operating-airline">
                     <span class="operated-by"> {{ $t("flightCard_operatedBy") }} : </span>
                     <span class="airline">{{ flight.operatingAirline }}</span>
                  </div>
               </div>
            </div>

            <!-- Charter Badge Mobile -->
            <div class="flightcard-header-right">
               <span class="is-charter" v-if="flight.isCharter">charter</span>
               <div class="badge-wrapper">
                  <div class="badge-item is-ethnic" v-if="flight.paxSubType != 0">{{ $t("flightCard_paxSubType") }}</div>
               </div>
            </div>
         </div>

         <div :data-flightNumber="flight.flightNumber" class="flightcard-basics-wrapper" @click="handlerSelectFlight">
            <div class="badge-wrapper">
               <div class="badge-item is-charter d-none d-lg-block" v-if="flight.isCharter">charter</div>

               <div class="badge-item is-ethnic d-none d-lg-block" v-if="flight.paxSubType != 0">{{ $t("flightCard_paxSubType") }}</div>
               <div
                  class="badge-item is-family-offer d-none d-lg-block"
                  :class="getClassForFamilyPriceView(flight.cheapestFamilyPrice?.price)"
                  v-if="familyPricesToggle && flight.cheapestFamilyPrice?.price && !isCheckOutEnabled && !flight.isSelected">
                  {{ $t("flightCardComponent_lblPricePackage") }}: <strong>{{ flight.cheapestFamilyPrice?.price | price(currency) }}</strong>
               </div>
            </div>

            <template v-if="false">
               <div class="cheapest-family-offer" :class="getClassForFamilyPriceView(flight.cheapestFamilyPrice?.price)" v-if="flight.cheapestFamilyPrice?.price">
                  <i class="gts-icon icon-sm icon-package"></i>
                  <span> {{ $t("searchComponentFlight_cheapestPrice") }}</span>
                  <span>{{ flight.cheapestFamilyPrice?.price | price(currency) }}</span>
               </div>
            </template>

            <!-- SELECT BUTTON -->
            <div class="flightcard-selection-wrapper">
               <div class="flightcard-selection-checkmark"></div>
            </div>

            <!-- AIRLINE INFORMATION -->
            <div class="flightcard-airline-informations d-none d-lg-flex">
               <img class="airline-logo" :src="handlerAirlineImg(flight.marketingAirlineCode)" alt="" @error="handlerUnknownImg($event)" />
               <span class="marketing-airline-name">{{ flight.marketingAirline }}</span>
               <span class="flight-channel" v-if="isChannel">{{ flight.channel }}</span>
            </div>

            <!-- PRICE & CABINTYPE INFORMATIONS -->
            <div class="flightcard-main-informations-wrapper">
               <!-- Tekli Gösterim -->
               <template>
                  <div class="flightcard-main-informations" :class="[isPackagePrice() ? 'single-view' : '', flight.familyPrice == 0 && flight.price == 0 ? 'hide-from-ui' : '']">
                     <!-- Price Section -->
                     <div class="flightcard-price-wrapper">
                        <!-- Display if it is one way  -->

                        <template v-if="flight.price == 0 && flight.familyPrice == 0 && typeof flight.familiesPackagePrices == 'undefined'">
                           <span class="flightcard-price-oneway"> {{ $t(`flightCardComponent_lblPriceSingle`) }}</span>
                        </template>

                        <template v-else>
                           <!-- Display if discount -->
                           <template v-if="flight.familyPrice != 0 && flight.familyPrice != null && flight.price != flight.familyPrice">
                              <span class="flightcard-single-price"> {{ $t(`flightCardComponent_lblPriceSingle`) }}</span>
                              <span class="flightcard-discount" v-if="isPackagePrice()"> {{ flight.price | price(currency) }} </span>
                              <span class="flightcard-price cut-price family-price" v-if="isPackagePrice()"> {{ flight.familyPrice | price(currency) }}</span>
                              <span class="flightcard-price cut-price" v-else> {{ flight.price | price(currency) }}</span>
                           </template>

                           <template v-if="flight.familyPrice === 0 || flight.familyPrice == null || flight.price === flight.familyPrice">
                              <span class="flightcard-single-price" v-if="!isOneWay"> {{ $t(`flightCardComponent_lblPriceSingle`) }} </span>
                              <span class="flightcard-price"> {{ flight.price | price(currency) }}</span>
                           </template>
                        </template>
                     </div>

                     <template v-if="!isPackagePrice()">
                        <span class="flightcard-cabintype">{{ flight.cabinType | EFltCabinType }} </span>

                        <div class="flightcard-baggage-seat-informations">
                           <div class="baggage-wrapper">
                              <i class="gts-icon icon-xs icon-baggage"></i>
                              <span class="baggage-information" v-if="flight.baggage.status">{{ flight.baggage.info }}</span>
                              <span class="baggage-information" v-else>{{ flight.baggage.info }}</span>
                           </div>
                           <div class="seat-wrapper">
                              <i class="gts-icon icon-xs icon-seat"></i>
                              <span class="seat-information">{{ flight.leftSeat }}</span>
                           </div>
                        </div>
                     </template>
                  </div>
               </template>

               <!-- Package  Gösterim -->
               <template>
                  <div class="flightcard-main-informations package-price" v-if="isPackagePrice()">
                     <!-- Price Section -->
                     <div class="flightcard-price-wrapper">
                        <template>
                           <!-- Display if discount -->
                           <template>
                              <span class="flightcard-single-price"> {{ $t(`flightCardComponent_lblPricePackageShorter`) }}</span>
                              <span class="flightcard-price cut-price"> {{ flight.familiesPackagePrices | price(currency) }}</span>
                           </template>
                        </template>
                     </div>

                     <template>
                        <span class="flightcard-cabintype">{{ flight.cabinType | EFltCabinType }} </span>

                        <div class="flightcard-baggage-seat-informations">
                           <div class="baggage-wrapper">
                              <i class="gts-icon icon-xs icon-baggage"></i>
                              <span class="baggage-information" v-if="flight.baggage.status">{{ flight.baggage.info }}</span>
                              <span class="baggage-information" v-else>{{ flight.baggage.info }}</span>
                           </div>
                           <div class="seat-wrapper">
                              <i class="gts-icon icon-xs icon-seat"></i>
                              <span class="seat-information">{{ flight.leftSeat }}</span>
                           </div>
                        </div>
                     </template>
                  </div>
               </template>
            </div>

            <FlightCardInfoGraphic :segments="flight.segments" :transfer-time="flight.transferTime" :connection="flight.connection" />

            <!-- SHOW/HIDE DETAILS  -->
            <div class="flightcard-details-toggle d-none d-xxl-inline-flex" :class="showDetails ? 'hide-details' : ''" data-toggle>
               <i class="gts-icon icon-arrow-down icon-sm"></i>
            </div>
         </div>

         <FlightCardDebugger :infos="Debugger" v-if="isDebugger" />

         <FlightCardDetails v-if="showDetails" :details="flight.details" />

         <!-- FlightCard Footer -->
         <div class="flightcard-footer-wrapper">
            <!-- Last Seat Attention -->
            <span class="last-seat-attention" :class="flight.leftSeat <= 9 ? 'seat-visible' : ''">
               <i class="gts-icon icon-flame icon-xs"></i>
               {{ $t("searchComponentFlight_lastSeat") }} {{ flight.leftSeat }}
            </span>

            <!-- Operating Airlines -->
            <span class="operating-airline-name d-none d-xl-block" v-if="flight.operatingAirlineCode != flight.marketingAirlineCode"
               >{{ $t("flightcardcomponent_operatedBy") }}: {{ $t(`airlineEnum_${flight.operatingAirlineCode}`) }}
            </span>

            <!--  Show Details Mobile -->
            <div class="flightcard-details-toggle d-xxl-none" :class="showDetails ? 'hide-details' : ''" data-toggle @click="showDetails = !showDetails">
               <i class="gts-icon icon-eye-closed" v-if="showDetails"></i>
               <i class="gts-icon icon-eye" v-else></i>
               <span class="toggle-detail-txt">{{ $t("flightCard_showDetails") }}</span>
            </div>

            <!-- Connections -->
            <span class="connections d-none d-xxl-block">
               {{ flight.stopCount }}
            </span>
         </div>
      </template>
   </div>
</template>

<script>
import { format24hours, convertToHour } from "@/helper/flight.js";
import FlightCardInfoGraphic from "@/components/structural/flight/search/search-results/flight-card/FlightCardInfoGraphic.vue";
import FlightCardDebugger from "@/components/structural/flight/search/search-results/flight-card/FlightCardDebugger.vue";
import FlightCardDetails from "@/components/structural/flight/search/search-results/flight-card/FlightCardDetails.vue";

export default {
   name: "FlightCard",
   props: {
      flight: {
         type: Object,
         required: true,
      },
      flightIndex: Number,
      legIndex: Number,
      currency: String,
      cheapest: Object,
      familyPricesToggle: Boolean,
      paxsubtype: Number,
      isCheckOutEnabled: Boolean,
      priceViewMode: Number,
      isOneWay: Boolean,
      isDebugger: Boolean,
      isChannel: Boolean,
   },
   components: {
      FlightCardInfoGraphic,
      FlightCardDebugger,
      FlightCardDetails,
   },
   data() {
      return {
         showDetails: false,
      };
   },
   mounted() {
      // document.body.addEventListener("keydown", (event) => {
      //    let held = false;
      //    if (event.ctrlKey && event.altKey) {
      //       held = true;
      //    }
      //    if (held && event.keyCode == 73) {
      //       this.isDebugger = !this.isDebugger;
      //    }
      //    if (held && event.keyCode == 84) {
      //       this.isChannel = !this.isChannel;
      //    }
      // });
   },

   computed: {
      FlightCardPriceData() {
         return {
            familiesPackagePrices: this.flight.familiesPackagePrices,
            familyPrice: this.flight.familyPrice,
            cheapestFamilyPrice: this.flight.cheapestFamilyPrice,
            price: this.flight.price,
            currency: this.currency,
            cabinType: this.$options.filters.EFltCabinType(this.flight.cabinType),
            baggage: this.flight.baggage,
            leftSeat: this.flight.leftSeat,
            isSelected: this.flight.isSelected,
         };
      },
      FamilyPriceView() {
         return this.$parent.BasketCreatedAndHasSelection;
      },
      FilterBy() {
         const storeShortCut = this.$store.state.flight.filters[this.flight.legIndex].filters;

         //car filter options helper variables
         const departureTime = this.flight.segments[0].time;
         const arrivalTime = this.flight.segments[Object.keys(this.flight.segments).length - 1].time;
         const baggageAllowance = this.flight.baggage.status ? "withbaggage" : "nobaggage";

         //Card filter options
         const connection = storeShortCut.connections[this.flight.connection].checked;
         const cabintype = storeShortCut.cabintype[this.flight.cabinType].checked;
         const airlines = storeShortCut.airlines[this.flight.marketingAirlineCode].checked;
         const dpTakeOff = format24hours(storeShortCut.hours.departure[0]) <= departureTime;
         const dpLanding = format24hours(storeShortCut.hours.departure[1]) >= departureTime;
         const rtTakeoff = format24hours(storeShortCut.hours.arrival[0]) <= arrivalTime;
         const rtLanding = format24hours(storeShortCut.hours.arrival[1]) >= arrivalTime;
         const baggage = storeShortCut.baggage[baggageAllowance].checked;

         return connection && cabintype && airlines && dpTakeOff && dpLanding && rtTakeoff && rtLanding && baggage;
      },
      Debugger() {
         return {
            channel: this.flight.channel,
            identifier: this.flight.identifier,
            debugger: this.flight.debugger,
         };
      },
   },

   methods: {
      isPackagePrice() {
         if (this.isCheckOutEnabled) {
            // return this.flight.familiesPackagePrices != 0 && this.flight.familiesPackagePrices != undefined && this.priceViewMode == 1;
            return this.flight.familiesPackagePrices != 0 && this.flight.familiesPackagePrices != undefined && this.priceViewMode == 1;
         } else {
            return this.flight.familiesPackagePrices != 0 && this.flight.familiesPackagePrices != undefined;
         }
      },
      getClassForFamilyPriceView(cheapestFamilyPrice) {
         const { basketCreated, thisLegHasSelection, showKe, checkoutEnabled } = this.FamilyPriceView;

         // Check for the specific condition where all are false
         if (!basketCreated && !thisLegHasSelection && showKe.length === 0 && !checkoutEnabled) {
            return "green";
         }

         // Original conditions
         if (basketCreated && thisLegHasSelection && ((Array.isArray(showKe) && showKe.includes(cheapestFamilyPrice) && checkoutEnabled) || !checkoutEnabled)) {
            return "green";
         }

         return "gray";
      },
      handlerSelectFlight(ev) {
         const isNotSelection = ev.target.hasAttribute("data-toggle");
         if (isNotSelection) {
            this.showDetails = !this.showDetails;
         } else {
            this.$store.commit("flight/setLegSelection", { status: true, legIndex: this.legIndex, price: this.flight.price });
            this.$emit("selected-flight", { identifier: this.flight.identifier, index: this.flightIndex });
         }

         const sameDayFlight = this.$parent.$parent.$parent.$parent.$parent.sameDayFlight;
         if (sameDayFlight) {
            this.handlerSameDayControll();
         }
      },
      handlerSameDayControll() {
         const departureTime = convertToHour(this.flight.segments[0].time) - 2;
         const arrivalTime = convertToHour(this.flight.segments[Object.keys(this.flight.segments).length - 1].time) + 2;

         const otherFilter = this.legIndex == 1 ? 2 : 1;

         if (this.legIndex == 1) {
            const current = this.$store.state.flight.filters[otherFilter].filters.hours.departure[1];
            this.$store.state.flight.filters[otherFilter].filters.hours.departure = [arrivalTime, current];
         } else {
            const current = this.$store.state.flight.filters[otherFilter].filters.hours.arrival[0];
            this.$store.state.flight.filters[otherFilter].filters.hours.arrival = [current, departureTime];
         }
      },
      handlerAirlineImg(airlineLogo) {
         return `${this.$constants.cdn}/airline_34x34/${airlineLogo}.svg`;
      },
      handlerUnknownImg(ev) {
         ev.target.src = `${this.$constants.cdn}/airline_34x34/00.svg`;
      },
   },
};
</script>

<style lang="scss" scoped>
.green {
   .flightcard-basics-wrapper {
      padding: 1rem !important;
      padding-top: 2rem !important;
   }
}
$familyPriceColor: #57efc1;
.single-view {
   padding: 0.25rem 0rem !important;
   padding-bottom: 0rem !important;

   .flightcard-single-price {
      font-size: 15px;
      top: -2rem;
   }

   &.hide-from-ui {
      display: none !important;
   }
}
.package-price {
   opacity: 1 !important;
   cursor: pointer !important;
   margin-top: 1.75rem;
   border: 3px solid $familyPriceColor !important;
   border: 3px solid #27c077 !important;
   // background-color: rgb(226, 255, 252) !important;
   // box-shadow: 0px 0px 0px 4px var(--accent-primary-lightest) !important;
   // -webkit-box-shadow: 0px 0px 0px 4px var(--accent-primary-lightest) !important;
   // -moz-box-shadow: 0px 0px 0px 4px var(--accent-primary-lightest) !important;
   //deneme
   background-color: var(--accent-primary-lightest);
   background-color: #edfff6 !important;
   border: 3px solid var(--accent-primary);
   box-shadow: 0px 0px 0px 4px var(--accent-primary-lightest);
   -webkit-box-shadow: 0px 0px 0px 4px var(--accent-primary-lightest);
   -moz-box-shadow: 0px 0px 0px 4px var(--accent-primary-lightest);
   transform: scale(1) !important;

   .cut-price {
      // background-color: #e9fcf2;
      color: #19c06c !important;
      color: var(--primary) !important;
      color: #2eb892 !important;
      color: #23aa6b !important;
      color: #118b52 !important;
      border-radius: 0.25rem;
   }
}

span.flightcard-cabintype {
   text-align: center;
   border-radius: 0.5rem;
   font-size: var(--small);
   font-weight: 500;
   color: #363636;
   width: fit-content;
}
.flightcard-baggage-seat-informations {
   display: flex;
   flex-direction: row;
   margin-top: 0.25rem;

   .baggage-wrapper,
   .seat-wrapper {
      display: flex;
      margin: 0 0.25rem;

      span {
         color: var(--secondary);
         font-size: var(--small);
         font-weight: 500;
      }
   }
}
.flightcard-single-price {
   position: absolute;
   top: -2.125rem;
   font-size: 17px;
   // background: #fff;
   padding: 0 0.5rem;
   border-radius: 0.5rem;
   // border: 1px solid #ccc;
   color: #121e1d;
   font-weight: 600;
   white-space: nowrap;
}

.badge-wrapper {
   position: absolute;
   top: 0;
   right: 0;
   display: flex;
   gap: 0.25rem;

   .badge-item {
      border-radius: 5px !important;
      margin-right: 0.125rem;
      border-radius: 5px;
      padding: 0.15rem 0.5rem;
      font-size: var(--small);
      font-weight: 500;

      &:last-child {
         border-top-left-radius: 0;
         border-top-right-radius: 0.75rem !important;
         border-bottom-right-radius: 0;
         margin-right: 0 !important;
      }

      &.is-charter {
         background-color: #ff4c4c;
         color: #fff !important;
         outline: 1px solid #ff4c4c;
      }
      &.is-ethnic {
         background-color: #c057ff;
         outline: 1px solid #c057ff;
         color: #fff !important;
      }
      &.is-family-offer {
         // background-color: #a9ffd4;
         font-weight: 400;

         strong {
            font-size: 1rem;
            font-weight: 600 !important;
         }
         &.gray {
            background-color: #d1d0d0;
            color: #696969;
            display: none !important;
         }
         &.green {
            border-top-left-radius: 0 !important;
            border-bottom-right-radius: 0 !important;
            background-color: $familyPriceColor;
            background-color: $familyPriceColor;
            outline: 1px solid $familyPriceColor;
            outline: 1px solid $familyPriceColor;
            border: none !important;
         }
      }
   }

   .is-charters {
      background-color: #ff4c4c;
      // border-radius: 5px;
      // border-top-left-radius: 0;
      // border-top-right-radius: 0.5rem;
      // border-bottom-right-radius: 0;
      font-size: var(--xsmall);
      color: #fff;
      padding: 0.15rem 0.5rem;
      text-transform: uppercase;
      font-weight: 600;
   }
   .is-ethnics {
      background-color: #ca4bff;
      border-radius: 5px;
      // border-top-left-radius: 0;
      // border-top-right-radius: 0.5rem;
      // border-bottom-right-radius: 0;
      font-size: var(--xsmall);
      color: #fff !important;
      padding: 0.15rem 0.5rem;
      text-transform: uppercase;
      font-weight: 600;
   }
   .is-family-offers {
      background-color: #57ff65;
      border-radius: 5px;
      font-size: var(--xsmall);
      color: #fff;
      padding: 0.15rem 0.5rem;
      text-transform: uppercase;
      font-weight: 400;
   }
}

.best-offer {
   background-color: var(--accent-primary);
   width: fit-content;
   padding: 0.25rem 1rem;
   border-radius: 1rem;
   border-top-right-radius: 0;
   border-bottom-left-radius: 0;
   color: #fff;
   font-weight: 600;
   position: absolute;
   left: 0;
   top: 0;
}

.cheapest-family-price {
   position: relative;
   &::after {
      content: "*";
      position: absolute;
      top: 0;
      left: 0;
   }
}
.cheapest-family-offer {
   // background-color: #363636;
   padding: 0.25rem 0.5rem;
   border-radius: 0.75rem;
   margin-top: 0.5rem;
   text-align: center;
   color: #363636;
   width: -moz-fit-content;
   width: fit-content;
   display: flex;
   flex-direction: column;
   align-items: center;

   &.gray {
      display: none;
      background-color: #dddddd;
      color: #696969;
   }
   &.green {
      // background-color: red;
   }
   span {
      font-weight: 500;
      font-size: 1rem;
      &:first-child {
         line-height: 1rem;
         font-size: 0.85rem;
         font-weight: 400;
      }
      // &:last-child {
      //    margin-top: 0.25rem;
      //    font-weight: 600;
      // }
   }
}
.flightcard-main-informations-wrapper {
   width: fit-content;
   align-items: center;
   display: flex;
   flex-direction: column;

   @media (min-width: 992px) {
      margin-left: 1rem;
   }
   @media (min-width: 1400px) {
      margin-left: 1.5rem;
      padding: 0.75rem 0.25rem;
   }
}
.flightcard-inner-wrapper {
   position: relative;
   // background-color: #fff;
   // background-color: #fcfcfd;
   // // background-color: #f9f9fb;
   // // background-color: #f8f8fb; //saturated
   background-color: #fbfbfd; //saturated
   background-color: #fff; //saturated
   border: 1.5px solid #ccc;
   margin-bottom: 1.125rem;
   border-radius: 1rem;
   // box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
   // box-shadow: rgba(0, 0, 0, 0.1) 0px 20px 25px -5px, rgba(0, 0, 0, 0.04) 0px 10px 10px -5px;
   // box-shadow: rgba(0, 0, 0, 0.15) 0px 3px 3px 0px;
   // box-shadow: rgba(0, 0, 0, 0.45) 0px 25px 20px -20px;
   cursor: pointer;
   outline: 3px solid transparent;
   transition-property: all;
   transition-timing-function: ease-in-out;
   // transition-duration: 1ms;

   .flightcard-header {
      background-color: #eee;
      padding: 0.25rem 0.5rem;
      border-radius: 1rem;
      border-bottom-right-radius: 0;
      border-bottom-left-radius: 0;
      height: 52px;
      display: flex;
      justify-content: space-between;

      .flightcard-header-left {
         display: flex;
         align-items: center;
         img {
            $size: 34px;
            width: $size;
            height: $size;
            margin-right: 0.75rem;
         }
         .airline-informations {
            .marketing-airline,
            .operating-airline {
               span {
                  font-size: var(--small);
               }
               span.airline,
               span.flight-number {
                  font-weight: 500;
               }
               span.flight-number {
                  margin-left: 0.5rem;
               }
            }
            .operating-airline {
               color: #626262;
               font-size: var(--xsmall) !important;
            }
         }
      }
      .flightcard-header-right {
         display: flex;
         align-items: center;
         .is-charter {
            margin-left: 0.5rem;
            background-color: #fff;
            border: 2px solid #ff4c4c;
            color: #ff4c4c;
            border-radius: 0.5rem !important;
            font-size: var(--xsmall);
            padding: 0.15rem 0.5rem;
            text-transform: uppercase;
            font-weight: 600;
         }

         i {
            display: none;
         }
      }
   }

   &.de-emphasize {
      .flightcard-main-informations {
         opacity: 0.5 !important;
         transform: scale(0.9) !important;
      }
   }

   &.is-selected {
      .flightcard-basics-wrapper {
         .flightcard-main-informations {
            background-color: var(--accent-primary-lightest);
            border: 3px solid var(--accent-primary);
            box-shadow: 0px 0px 0px 4px var(--accent-primary-lightest);
            -webkit-box-shadow: 0px 0px 0px 4px var(--accent-primary-lightest);
            -moz-box-shadow: 0px 0px 0px 4px var(--accent-primary-lightest);
         }
         .flightcard-selection-wrapper {
            border: 2px solid var(--accent-primary);
            .flightcard-selection-checkmark {
               display: block !important;
               $size: 20px;
               width: $size;
               height: $size;
               background: var(--accent-primary);
               border-radius: 50%;
               opacity: 1;
            }
         }
      }
   }
   &.is-package {
      // border: 2.5px solid #03ffe5;
      .flightcard-basics-wrapper {
         .flightcard-main-informations {
            opacity: 0.4;
            cursor: not-allowed;
            transform: scale(0.85);

            // background-color: #eefffd;
            // border: 3px solid #fff;
            // box-shadow: 0px 0px 0px 4px var(--accent-primary-lightest);
            // -webkit-box-shadow: 0px 0px 0px 4px var(--accent-primary-lightest);
            // -moz-box-shadow: 0px 0px 0px 4px var(--accent-primary-lightest);

            .flightcard-price {
               // color: #1dc973 !important;
            }
         }
      }
   }

   &:hover {
      background-color: #f5f5f5;

      .flightcard-details-toggle {
         background-color: #fff !important;
         border: 2px solid #ccc;
         // background-color: red;
      }
      .flightcard-selection-wrapper {
         transform: scale(1.05);
      }

      ::v-deep .flight-icon-container {
         background-color: #f7f7f7 !important;
         transform: scale(1.15);
      }
   }
   &.has-family-price {
      outline: 3px solid var(--accent-secondary);
      outline: 4px solid $familyPriceColor;
      border: 1px solid transparent;
      .is-charter {
         // border-top-right-radius: 1rem !important;
      }

      &.not-has-family-pricek {
         outline: none !important;
      }
   }
   &.flightcard-collapsed,
   &.lazy-loaded-collapsed-leg {
      display: none;
   }
   &.details-active {
      background: #fff;
   }
}
.flightcard-inner-wrapper {
   .flightcard-basics-wrapper {
      display: flex;
      align-items: center;
      padding: 1rem;
      padding-bottom: 1rem;
      padding-top: 1.5rem;
      width: 100%;
      justify-content: space-between; //check here
      flex-direction: row-reverse;
      @media (min-width: 992px) {
         flex-direction: row;
      }

      .flightcard-selection-wrapper {
         $size: 28px;
         width: $size;
         height: $size;
         display: inline-flex;
         flex-shrink: 0;
         border: 3px solid #929292;
         border-radius: 50%;
         align-items: center;
         justify-content: center;
         background-color: #fff;
         transition-property: transform;
         // transition-duration: 0.1s;
         transition-timing-function: ease-in-out;
         margin-right: 1rem;
         @media (max-width: 1800px) {
            display: none;
         }

         .flightcard-selection-checkmark {
            opacity: 0;
            transition-property: opacity;
            transition-timing-function: ease-in-out;
            // transition-duration: 0.1s;
         }

         &.is-selected {
            border: 2px solid var(--accent-primary);
            .flightcard-selection-checkmark {
               display: block !important;
               $size: 20px;
               width: $size;
               height: $size;
               background: var(--accent-primary);
               border-radius: 50%;
               opacity: 1;
            }
         }
      }
      .flightcard-details-toggle {
         display: inline-flex;
         flex-shrink: 0;
         align-items: center;
         justify-content: center;
         $size: 42px;
         width: 36px;
         height: $size;
         // border: 2px solid #b5b5b5;
         border-radius: 0.5rem;
         background-color: #e4e4e4;

         i {
            margin-top: 3px;
            pointer-events: none;
            transform: rotate(0deg);
            transition-property: transform;
            transition-timing-function: ease-out;
            // transition-duration: 0.25s;
         }

         &.hide-details {
            i {
               transform: rotate(180deg);
            }
         }
      }
      .flightcard-airline-informations {
         display: flex;
         flex-direction: column;
         align-items: center;
         max-width: 65px;
         img.airline-logo {
            $airlineLogoSize: 40px;
            width: $airlineLogoSize;
            height: $airlineLogoSize;
         }
         span.marketing-airline-name {
            font-size: var(--xsmall);
            margin-top: 0.25rem;
            font-weight: 500;
            text-align: center;
            width: 70px;
            word-wrap: normal;
         }
         span.flight-number {
            font-weight: 400;
            font-size: var(--xsmall);
            color: #363636;
         }
         span.flight-channel {
            color: #ff4c4c;
            font-size: var(--xsmall);
            font-weight: 500;
         }
      }

      .flightcard-main-informations {
         display: flex;
         flex-direction: column;
         align-items: center;
         border: 1px solid #ccc;
         border-radius: 1rem;
         padding: 0.35rem 0rem;
         background-color: #fcfcfc;
         min-width: 100px;
         &.opacity {
            // transform: scale(0.9);
            opacity: 1;
            cursor: not-allowed;
            display: none;
         }

         div.flightcard-price-wrapper {
            position: relative;
            display: flex;
            flex-direction: column;
            align-items: center;

            .flightcard-discount {
               position: absolute;
               top: -0.5rem;
               font-size: 13px;
               color: var(--txt-ghost);
               text-decoration: line-through;
               background: #fafafa;
               padding: 0 0.5rem;
               // border: 1px solid #cccccc;
               border-radius: 0.5rem;
               z-index: 2;
               font-weight: 500;
            }
            .flightcard-basket-price-txt {
               position: absolute;
               top: -1.75rem;
               font-size: 15px;
               color: #00c5b1;
               font-weight: 500;
               background: #fafafa;
               // padding: 0 0.5rem;
               // border: 1px solid #cccccc;
               border-radius: 0.5rem;
            }
            .flightcard-price {
               text-align: center;
               font-size: 1.45rem;
               font-weight: 800;
               color: var(--primary);
               // margin-bottom: 1rem;
               padding: 0.125rem 0.35rem;
               position: relative;

               &.basket-price {
                  color: #00c5b1;
                  // background-color: #e9fcf2;
                  // color: #1dc973 !important;
                  // border-radius: 0.25rem;
               }
            }
         }
         span.flightcard-price-oneway {
            text-align: center;
            text-decoration: line-through;
            font-size: var(--small);
            font-weight: 600;
            color: var(--primary);
            margin-bottom: 0.25rem;
            display: block;
         }
      }
   }
   .flightcard-footer-wrapper {
      display: flex;
      border-top: 1px solid #ccc;
      background-color: #eee;
      padding: 0.25rem 1rem;
      border-bottom-left-radius: 1rem;
      border-bottom-right-radius: 1rem;
      justify-content: space-between;
      align-items: center;

      .last-seat-attention {
         display: flex;
         color: var(--txt-black);
         font-weight: 500;
         font-size: 0.85rem;
         align-items: center;
         border-radius: 1rem;
         visibility: hidden;

         &.seat-visible {
            color: #ff4c4c;
            visibility: visible;
         }

         i {
            margin-right: 0.25rem;
            width: 14px !important;
            height: 14px !important;
            filter: invert(38%) sepia(45%) saturate(3741%) hue-rotate(336deg) brightness(116%) contrast(90%);
         }
      }
      .flightcard-details-toggle {
         display: flex;
         align-items: center;
         i {
            width: 30px !important;
         }
         .toggle-detail-txt {
            margin-left: 0.25rem;
            font-size: var(--small);
            font-weight: 500;
            color: var(--txt-gray);
         }
      }
      span.connections {
         font-size: var(--small);
         font-weight: 500;
      }
      span.operating-airline-name {
         font-size: var(--small);
         font-weight: 500;
         color: var(--gray-lighten);
      }
   }
}
</style>
